import { compose, setDisplayName, withProps } from 'recompose';

import {
  KEY_TEXT_QUESTION_FONT_COLOR,
  KEY_TEXT_QUESTION_FONT_FAMILY,
  KEY_TEXT_QUESTION_FONT_SIZE,
  KEY_TEXT_QUESTION_FONT_STYLE,
  KEY_TEXT_QUESTION_FONT_WEIGHT,
  KEY_TEXT_QUESTION_TEXT_DECORATION,
  KEY_TEXT_QUESTION_TEXT_TRANSFORM,
} from '../../const/keysBlockStyling';

const StylingToCSSTextQuestion = withProps(
  ({
    styling: {
      [KEY_TEXT_QUESTION_FONT_COLOR]: color,
      [KEY_TEXT_QUESTION_FONT_FAMILY]: fontFamily,
      [KEY_TEXT_QUESTION_FONT_SIZE]: fontSize,
      [KEY_TEXT_QUESTION_FONT_STYLE]: fontStyle,
      [KEY_TEXT_QUESTION_FONT_WEIGHT]: fontWeight,
      [KEY_TEXT_QUESTION_TEXT_DECORATION]: textDecoration,
      [KEY_TEXT_QUESTION_TEXT_TRANSFORM]: textTransform,
    } = {},
  }) => ({
    styleTextQuestion: {
      color,
      fontFamily,
      fontSize,
      fontStyle,
      fontWeight,
      textDecoration,
      textTransform,
    },
  }),
);

export default compose(
  setDisplayName('StylingToCSSTextQuestion'),
  StylingToCSSTextQuestion,
);
